import { Link } from "react-router-dom";
import { useLocale } from "@/contexts/LanguageContext";
import { practiceAreas } from "@/data/content";
import { useInView } from "@/hooks/useInView";

export function CapabilityBand() {
  const { t, getLocalizedHref } = useLocale();
  const { ref, inView } = useInView();

  return (
    <section ref={ref} className="py-16 md:py-20 border-y border-border/30">
      <div className="container mx-auto px-6 md:px-8 lg:px-10 max-w-7xl">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-4 md:gap-x-5 md:gap-y-5">
          {practiceAreas.map((area, i) => (
            <Link
              key={area.id}
              to={getLocalizedHref(area.href, area.esHref)}
              className={`micro-label text-muted-foreground hover:text-primary border border-border/40 hover:border-primary/40 px-7 py-3.5 rounded-full transition-all duration-300 hover:-translate-y-0.5 ${
                inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
              }`}
              style={{ transitionDelay: inView ? `${i * 50}ms` : "0ms" }}
            >
              {t(area.title)}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
